module.exports = __webpack_public_path__ + "static/media/Empty-Screen.5b90c92b.png";